export const absentPatientTurns = (absentPercentage) => {
  const { absentTurns } = absentPercentage
  if (absentTurns === 0) return 'Sin ausentismos'
  if (absentTurns === 1) return '1 turno ausente'
  return `${absentTurns} turnos ausentes`
}
